<template>
  <div>
    <div class="wrapper">
      <div class="title">
        {{index}}. {{ data.modelName }}
      </div>
      <div class="desc">
        {{ data.text }}
      </div>
      <div class="chart-wrapper">
        <el-tabs type="card">
          <el-tab-pane :label="chartTypeName(chart.imageType)" v-for="(chart,index) in this.jsonData.ruleOfInvoiceImageList"
             :key="index" >
          <ColumnChart :data="chart"
                       v-if="chart.imageType=='histogram'||chart.imageType=='twoHistogram'"
                       width="849px" height="435px"></ColumnChart>
          <LineChart :data="chart" v-if="chart.imageType=='brokenLine'" width="849px"
                     height="435px"></LineChart>
          <Pie :data="chart"
               v-if="chart.imageType=='annulus'"
               class="pie"></Pie>
          </el-tab-pane>
          <el-tab-pane label="表格">
            <GenericTable
              v-if="generalTableData"
              :data="generalTableData"
              :tips="tips"
              :subTables="subTables"
            ></GenericTable>
          </el-tab-pane>
        </el-tabs>

      </div>

    </div>
  </div>
</template>

<script>
import Pie from "../../../ResultEditor/components/InvoiceIndex/components/Pie";
import LineChart from "../chats/LineChart";
import ColumnChart from "../chats/ColumnChart";
import GenericTable from "../../../ResultEditor/components/InvoiceIndex/components/GenericTable";

export default {
  name: "Qian10da",
  components: {
    Pie,
    LineChart,
    ColumnChart,
    GenericTable
  },
  props: {
    data: Object,
    index:Number
  },
  computed: {
    pdfData(){
      return this.jsonData;
    },
    jsonData() {
      return JSON.parse(this.data.jsonData)
    },
    //通用表格
    generalTableData() {

      if (!this.pdfData) {
        return null;
      }

      if (!this.pdfData.body) {
        return null;
      }
      const ret = [];

      for (let i = 0; i < this.pdfData.body.length; i++) {
        ret[i] = [];

        this.pdfData.header.forEach(key => {

          ret[i].push(this.pdfData.body[i][key])
        })

      }

      return {
        data: ret,
        labels: this.pdfData.header
      };
    },
    tips() {
      return this.pdfData.tips && this.pdfData.tips.map(v => {
        return {
          pos: [v.row != null ? v.row : -1, v.col != null ? v.col : -1],
          text: v.text
        }
      })
    },
    subTables() {
      return this.pdfData.subTables && this.pdfData.subTables.map(v => {
        v.pos = [v.row != null ? v.row : -1, v.col != null ? v.col : -1]
        return v
      });
    },
  },
  methods:{
    chartTypeName(imageTypeId) {
      if (imageTypeId == 'histogram' || imageTypeId == 'twoHistogram') {
        return "柱形图"
      } else if (imageTypeId == 'brokenLine') {
        return "折线图"
      }else if (imageTypeId == 'annulus') {
        return "环形图"
      }


    },

  }
}
</script>

<style lang="stylus" scoped>
.wrapper
  padding 24px

  .title
    font-size: 20px;
    font-family: Helvetica;
    color: #061178;
    line-height: 30px;

  .desc
    margin-top 5px

  .chart-wrapper
    margin-top 50px

  .pie
    width 733px;
    margin 0 auto;
</style>
